import { useHead } from '@unhead/react';
import { useTranslation } from 'translations/hooks';

import { MobileSingleCardPageWithFilterLayout } from 'business/layout/single-card-page-with-filter-card/mobile';
import { RingTableFilterData } from 'business/production-and-performance/pages/ring-table';
import { RingsTableFilters } from 'business/production-and-performance/pages/ring-table/mobile/components/ring-table-filters';
import { MobileRingsTableWithPagination } from 'business/production-and-performance/pages/ring-table/mobile/components/ring-table-pagination';
import { ProdAndPerfFiltersProvider } from 'business/production-and-performance/providers/prod-and-perf-filters-provider';
import { useFilterData } from 'technical/filter-data';

export const MobileRingTable = () => {
  const { t } = useTranslation();

  const { filterData, setFilterData } = useFilterData<RingTableFilterData>();

  useHead({ title: t('user.menu.sections.prodPerf.ringList.title') });

  return (
    <ProdAndPerfFiltersProvider
      initialFilters={{
        filterType: 'ring',
        dayMode: 'calendar',
        ringRange: [null, null],
      }}
    >
      <MobileSingleCardPageWithFilterLayout
        title={t('productionAndPerformance.ring.title')}
        filters={<RingsTableFilters filterData={filterData} />}
      >
        <MobileRingsTableWithPagination setFilterData={setFilterData} />
      </MobileSingleCardPageWithFilterLayout>
    </ProdAndPerfFiltersProvider>
  );
};
